import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-[70px]">
          <div className="flex items-center">
            <img 
              src={process.env.PUBLIC_URL + "/scratchflix-logo.png"} 
              alt="Scratchflix Logo" 
              className="h-16 w-auto"
            />
          </div>

          <div className="hidden md:flex space-x-8">
            <button onClick={() => scrollToSection('accueil')} className="nav-link">
              Accueil
            </button>
            <button onClick={() => scrollToSection('qui-sommes-nous')} className="nav-link">
              Qui sommes-nous
            </button>
            <button onClick={() => scrollToSection('tutoriels')} className="nav-link">
              Tutoriels
            </button>
            <button onClick={() => scrollToSection('creations')} className="nav-link">
              Nos Créations
            </button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">
              Contact
            </button>
          </div>

          <button
            className="md:hidden text-[#2C3E50]"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <button onClick={() => scrollToSection('accueil')} className="mobile-nav-link">
              Accueil
            </button>
            <button onClick={() => scrollToSection('qui-sommes-nous')} className="mobile-nav-link">
              Qui sommes-nous
            </button>
            <button onClick={() => scrollToSection('tutoriels')} className="mobile-nav-link">
              Tutoriels
            </button>
            <button onClick={() => scrollToSection('creations')} className="mobile-nav-link">
              Nos Créations
            </button>
            <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">
              Contact
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;